import {
  ClipboardList,
  Clock,
  AlertTriangle,
  ArrowRightLeft,
  CalendarClock,
  Megaphone,
  MessageSquareMore,
  CheckCircle2,
  XCircle,
  Bug,
  MessageSquare,
  ClipboardCheck,
  UserPlus,
} from 'lucide-react';
import type { NotificationType } from '@hancomum/shared';

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  task_assigned:                '업무 배정',
  deadline_approaching:         '마감 임박',
  project_status_changed:       '프로젝트 상태 변경',
  urgent_changed:               '긴급 상태 변경',
  schedule_changed:             '일정 변경',
  system:                       '시스템',
  meeting_called:               '회의 소집',
  agenda_status_changed:        '안건 상태 변경',
  activity_approved:            '업무 승인',
  activity_rejected:            '업무 거절',
  issue_report_created:         '버그/개선 접수',
  issue_report_status_changed:  '버그/개선 상태 변경',
  issue_report_comment:         '버그/개선 댓글',
  notice_published:             '공지사항',
  project_request_created:      '프로젝트 등록 요청',
  project_request_approved:     '프로젝트 등록 승인',
  project_request_rejected:     '프로젝트 등록 반려',
  project_assigned:             '프로젝트 책임멤버 지정',
};

export const NOTIF_TYPE_CONFIG: Record<NotificationType, { icon: React.ElementType; color: string; bg: string }> = {
  task_assigned:          { icon: ClipboardList,     color: 'text-blue-600',   bg: 'bg-blue-100' },
  deadline_approaching:   { icon: Clock,             color: 'text-amber-600',  bg: 'bg-amber-100' },
  project_status_changed: { icon: ArrowRightLeft,    color: 'text-purple-600', bg: 'bg-purple-100' },
  urgent_changed:         { icon: AlertTriangle,     color: 'text-red-600',    bg: 'bg-red-100' },
  schedule_changed:       { icon: CalendarClock,     color: 'text-teal-600',   bg: 'bg-teal-100' },
  system:                 { icon: Megaphone,         color: 'text-gray-600',   bg: 'bg-gray-100' },
  meeting_called:         { icon: MessageSquareMore, color: 'text-orange-600', bg: 'bg-orange-100' },
  agenda_status_changed:  { icon: MessageSquareMore, color: 'text-indigo-600', bg: 'bg-indigo-100' },
  activity_approved:         { icon: CheckCircle2,      color: 'text-green-600',  bg: 'bg-green-100' },
  activity_rejected:         { icon: XCircle,            color: 'text-red-600',    bg: 'bg-red-100' },
  issue_report_created:      { icon: Bug,               color: 'text-red-600',    bg: 'bg-red-100' },
  issue_report_status_changed: { icon: AlertTriangle,   color: 'text-orange-600', bg: 'bg-orange-100' },
  issue_report_comment:      { icon: MessageSquare,     color: 'text-blue-600',   bg: 'bg-blue-100' },
  notice_published:          { icon: Megaphone,         color: 'text-orange-600', bg: 'bg-orange-100' },
  project_request_created:   { icon: ClipboardCheck,    color: 'text-blue-600',   bg: 'bg-blue-100' },
  project_request_approved:  { icon: CheckCircle2,      color: 'text-green-600',  bg: 'bg-green-100' },
  project_request_rejected:  { icon: XCircle,           color: 'text-red-600',    bg: 'bg-red-100' },
  project_assigned:          { icon: UserPlus,          color: 'text-slate-600',  bg: 'bg-slate-100' },
};
